<template>
<div class="chapter">
<div class="inner_page">
<p class="GFP_FM_Copyright">Published in <span class="smallcaps">2020</span> by<br/><span class="smallcaps">David R. Godine</span>, <span class="em_sw">Publisher</span><br/>Boston, Massachusetts<br/><a href="http://www.godine.com/" target="_blank"><span class="hyperlink_em">www.godine.com</span></a></p>
<p class="GFP_FM_Copyright">Copyright <span class="smallcaps">2020</span> © by Meredith Hall</p>
<p class="GFP_FM_Copyright"><span class="em_sw">All Rights Reserved</span>.<br/>No part of this book may be used or reproduced in any manner whatsoever without written permission from the publisher, except in the case of brief quotations embodied in critical articles and reviews. For more information, please write to the address above.</p>
<p class="GFP_FM_Copyright_Tspace"><span class="smallcaps">library of congress cataloging-in-publication data</span></p>
<p class="GFP_FM_Copyright">Names: Hall, Meredith, <span class="smallcaps">1949</span>- author.<br/>Title: Beneficence : a novel / Meredith Hall.<br/>Description: 1st. | Boston : David R. Godine, Publisher, [<span class="smallcaps">2020</span>] |</p>
<p class="GFP_FM_Copyright">Identifiers: <span class="smallcaps">lccn 2020019029</span> |<br/><span class="smallcaps">isbn 9781567926699</span> (hardcover) |<br/><span class="smallcaps">isbn 9781567926750</span> (ebook)<br/>Classification: <span class="smallcaps">lcc ps3608.a5474 b46 2020</span> | <span class="smallcaps">ddc 813/.6</span>--dc<span class="smallcaps">23</span><br/><span class="smallcaps">lc</span> record available at <a href="https://catalog.loc.gov/vwebv/search?searchCode=LCCN&amp;searchArg=2020019029&amp;searchType=1&amp;permalink=y" target="_blank"><span class="hyperlink">https://lccn.loc.gov/<span class="smallcaps">2020019029</span></span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?b62ee3c0